/* eslint-disable import/no-default-export */
import Chance from 'chance';

const chance = new Chance();

const generateResumeFileName = () =>
  `${chance.name().replace(' ', '')}${chance.pickone([
    '-',
    '_',
  ])}${chance.pickone([
    'cv',
    'resume',
    'curriculum',
  ])}-${chance.d10()}.${chance.pickone(['pdf', 'docx'])}`;

export default (): {
  id: string;
  createdDateUtc: string;
  fileMetadata: {
    name: string;
    size: string;
    uri: string;
    virusScanStatus: string;
    status: string;
  };
  isDefault: boolean;
  origin: {
    type: string;
  };
} => {
  const resumeId = chance.guid();
  const virusScanStatus = chance.pickone(['OK', 'Pending', 'HasVirus']);

  return {
    id: resumeId,
    createdDateUtc: new Date(
      chance.date({
        year: chance.natural({ min: 2008, max: 2018 }),
      }),
    ).toISOString(),
    fileMetadata: {
      name: generateResumeFileName(),
      size: `${chance.natural({ min: 200, max: 2000 })} KB`,
      uri: `/v2/blobstore/resumes/${resumeId}`,
      virusScanStatus,
      status: virusScanStatus,
    },
    isDefault: chance.bool(),
    origin: {
      type: chance.pickone(['Uploaded', 'Generated']),
    },
  };
};
